<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-model-item label="设备类型">
              <j-tree-select-custom
                @change="searchQuery"
                column="dev_class_code"
                dict="`iwt-wf`.dev_class,type_name,id"
                hasChildField="has_child"
                order="sort_no asc"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                returnKey="dev_class_code"
                v-model="queryParam.devClassCode"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="型号名称">
              <a-input placeholder="请输入型号名称" v-debounce="searchQuery" v-model="queryParam.modelName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="型号编码">
              <a-input placeholder="请输入型号编码" v-debounce="searchQuery" v-model="queryParam.modelCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('设备型号')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <div class="flex justify-center" v-else>
            <img :preview="text" :src="getImgView(text)" alt class="w-40px h-40px" height="25px" />
          </div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-model-modal @ok="modalFormOk" ref="modalForm"></dev-model-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevModelModal from './modules/DevModelModal'

  export default {
    name: 'DevModelList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevModelModal
    },
    data () {
      return {
        description: 'dev_model管理页面',
        queryParam: {},
        isorter: {
          column: 'modelName',
          order: 'asc'
        },
        // 表头
        columns: [
          {
            title: '设备类型',
            align: 'center',
            dataIndex: 'devClassCode_dictText',
            sorter: true
          },
          {
            title: '型号名称',
            align: 'center',
            dataIndex: 'modelName',
            sorter: true
          },
          {
            title: '型号编码',
            align: 'center',
            dataIndex: 'modelCode',
            sorter: true
          },
          {
            title: '生产厂家',
            align: 'center',
            dataIndex: 'manuId_dictText',
            sorter: true
          },
          {
            title: '设备照片',
            align: 'center',
            dataIndex: 'pictureObjId',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '运行寿命(天)',
            align: 'center',
            dataIndex: 'runningLife'
          },

          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/device/devModel/list',
          delete: '/device/devModel/delete',
          deleteBatch: '/device/devModel/deleteBatch',
          exportXlsUrl: '/device/devModel/exportXls',
          importExcelUrl: 'device/devModel/importExcel'
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'modelName', text: '型号名称' })
        fieldList.push({ type: 'string', value: 'modelCode', text: '型号编码' })
        fieldList.push({ type: 'int', value: 'devClassId', text: '设备类型ID' })
        fieldList.push({ type: 'int', value: 'manuId', text: '生产厂家ID' })
        fieldList.push({ type: 'string', value: 'pictureObjId', text: '设备照片(OSS服务对象ID)' })
        fieldList.push({ type: 'int', value: 'runningLife', text: '运行寿命(天)' })
        fieldList.push({ type: 'int', value: 'tenantId', text: '租户id' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司id' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
